import React, { useEffect, useState } from "react";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";

import { useLocation } from "react-router-dom";
import StudentHeader from "../students/v2/StudentHeader";
import { printImg } from "../master/Print";
import StudentDemo1 from "../components/StudentDemo1";
import { studentDetails } from "../../api/Student";

export default function StudentDemo() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const id = params.get("id") ?? "";
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);


  const getEnquiryData = async () => {
    if (!id) {
      return "";
    }
    setLoading(true);
    try {
      const response = await studentDetails(`id=${id}`);
      if (response.data) {
        setData(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getEnquiryData();
  }, []);

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <div className="col-2 left-pane">
                    <StudentHeader data={"Student Portal"} />
                  </div>
                  <div className="col-10">
                    <div className=" d-flex align-items-center justify-content-between">
                      <h4 className="text-primary">Student Demo From</h4>
                      <div className="text-end">
                        <button
                          className="btn btn-info me-1"
                          onClick={() => printImg("PrintDiv")}
                        >
                          <i className="ri-printer-line"></i>
                        </button>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-body">
                        <StudentDemo1 data={data} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
